import { api } from '../../server/api';
import { IKnowledgeTrail } from './types';

interface IKnowledgeTrailListResponse {
  error: boolean;
  message: string;
  body: IKnowledgeTrail[];
}

interface IFinishTrailResponse {
  error: boolean;
  message: string;
  body: IKnowledgeTrailCompletion;
}

export interface IKnowledgeTrailCompletion {
  globalScore: number;
  passed: boolean;
  pointsAwarded: number;
  completedAt: number;
  rating?: number;
  ratedAt?: number;
}

export async function getKnowledgeTrails(
  clientId: string,
  playerId: string
): Promise<IKnowledgeTrail[]> {
  const response = await api.get<IKnowledgeTrailListResponse>(
    `/knowledge-trail/player?clientId=${clientId}&playerId=${playerId}`
  );
  return response.data.body;
}

export async function finishKnowledgeTrail(
  trailId: string,
  playerId: string
): Promise<IFinishTrailResponse> {
  const response = await api.post(`/knowledge-trail/${trailId}/finish`, {
    playerId,
  });
  console.log('Finish trail API response:', response.data);
  return response.data;
}

export async function rateKnowledgeTrail(
  trailId: string,
  playerId: string,
  rating: number
): Promise<IFinishTrailResponse> {
  const response = await api.post(`/knowledge-trail/${trailId}/rating`, {
    playerId,
    rating,
  });
  return response.data;
}
